module.exports = __webpack_public_path__ + "img/bitpro.d7f3d36c.png";